import { EmailObjectSummary } from '../client/types';
import { StakeholderInformation } from '../client/types/CreateEmailObjectRequest';
import { createNavigationProvider, Route } from './core/NavigationContext';

export type AppRouteConfig = {
  welcome: never;
  login: never;
  main: { selectedTab?: string; createdStakeholderInformation?: StakeholderInformation };
  stakeholders: {
    firstName?: string;
    lastName?: string;
    email: string;
    projectIds?: number[];
  };
  summary: EmailObjectSummary;
};

const { NavigationProvider, useNavigation } = createNavigationProvider<AppRouteConfig>();

export { NavigationProvider, useNavigation };

export const routes: Route<AppRouteConfig>[] = [
  { name: 'welcome', resetStackOnNavigate: true },
  { name: 'login', resetStackOnNavigate: true },
  { name: 'main', resetStackOnNavigate: true },
  { name: 'stakeholders' },
  { name: 'summary', resetStackOnNavigate: true },
];
